import Kernel from './Kernel';

export class Map extends Kernel {
    constructor (target) {
        console.log('Module: Map has been loaded');

        super(target);

        this.data = target.data;
        this.$trigger = this.$el.find('.js-map-trigger');
        this.class = 'pointer-is-active';

        console.log(this.class);

        this.listeners();
    }

    listeners () {
        this.$trigger.on('click.Map', (e) => {
            const $current = $(e.currentTarget);

            if ($current.hasClass(this.class)) {
                $current.removeClass(this.class);
                return false;
            }

            this.$el.find(`.${this.class}`).removeClass(this.class);
            $current.addClass(this.class);
        });
    }
}

export default Map;



// WEBPACK FOOTER //
// ./app/src/js/modules/Map.js